import type { IPlanConditions, IPlanKey } from '../../types';

import { usePricingPlanActive } from '../usePricingPlanActive';
import { usePricingPlanData } from '../usePricingPlanData';

export interface ILimitationResult {
  planConditions: IPlanConditions | undefined;
  getLimitByPlanKey: (planKey?: IPlanKey) => IPlanConditions | undefined;
}

export const useLimitation = (): ILimitationResult => {
  const { activePlanKey } = usePricingPlanActive();
  const { getPlanDataByPlanKey } = usePricingPlanData();

  const planConditions = getPlanDataByPlanKey(activePlanKey)?.conditions;

  const getLimitByPlanKey = (planKey?: IPlanKey) => {
    return getPlanDataByPlanKey(planKey)?.conditions;
  };

  return {
    planConditions,
    getLimitByPlanKey,
  };
};
